/* global axios */
import ApiClient from './ApiClient';

class ResellerAPI extends ApiClient {
  constructor() {
    super('reseller/sub_accounts', { accountScoped: true });
  }

  contractDetails(id, page = 1) {
    return axios.get(`${this.url}/${id}`, { params: { page } });
  }

  getProfile() {
    return axios.get(`${this.url.replace('/sub_accounts', '')}/profile`);
  }

  updateProfile(formData) {
    return axios.patch(
      `${this.url.replace('/sub_accounts', '')}/profile`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
  }

  updateAmbassador(whatsapp) {
    return axios.patch(
      `${this.url.replace('/sub_accounts', '')}/profile/ambassador`,
      { whatsapp }
    );
  }

  resetProfile() {
    return axios.delete(`${this.url.replace('/sub_accounts', '')}/profile`);
  }

  getWholesale() {
    return axios.get(`${this.url.replace('/sub_accounts', '')}/wholesale`);
  }

  getCommissions() {
    return axios.get(`${this.url.replace('/sub_accounts', '')}/commissions`);
  }

  getWithdrawals() {
    return axios.get(`${this.url.replace('/sub_accounts', '')}/withdrawals`);
  }

  createWithdrawal({ amount, pixKey } = {}) {
    return axios.post(`${this.url.replace('/sub_accounts', '')}/withdrawals`, {
      amount,
      pix_key: pixKey,
    });
  }

  getOverview() {
    return axios.get(`${this.url.replace('/sub_accounts', '')}/overview`);
  }

  getPlans() {
    return axios.get(`${this.url.replace('/sub_accounts', '')}/plans`);
  }

  createPlan(plan) {
    return axios.post(`${this.url.replace('/sub_accounts', '')}/plans`, {
      plan,
    });
  }

  updatePlan(id, plan) {
    return axios.patch(`${this.url.replace('/sub_accounts', '')}/plans/${id}`, {
      plan,
    });
  }

  deletePlan(id) {
    return axios.delete(`${this.url.replace('/sub_accounts', '')}/plans/${id}`);
  }

  promoteSubAccount(id, partnerType = 'reseller') {
    return axios.post(`${this.url}/${id}/promote`, {
      partner_type: partnerType,
    });
  }

  setSubscription(id, { amount, billingType, resellerPlanId } = {}) {
    return axios.post(`${this.url}/${id}/set_subscription`, {
      amount,
      billing_type: billingType,
      reseller_plan_id: resellerPlanId,
    });
  }

  cancelSubscription(id) {
    return axios.delete(`${this.url}/${id}/cancel_subscription`);
  }

  resendInvoice(id) {
    return axios.post(`${this.url}/${id}/resend_invoice`);
  }
}

export default new ResellerAPI();
